import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from 'react-toastify';
import { IoHome } from "react-icons/io5";
import { PiKeyReturnFill } from "react-icons/pi";
import { useAuth } from "../../Context/AuthContext";
import "./EditDailyTournament.css";

const API = process.env.REACT_APP_API;

const EditDailyTournament = () => {
  const { id } = useParams(); // מזהה טורניר מה־URL
  const navigate = useNavigate();
  const { token } = useAuth();
  
  const [form, setForm] = useState(null);
  const [flyerFile, setFlyerFile] = useState(null);
  const [flyerPreview, setFlyerPreview] = useState(null);
  const [gallery, setGallery] = useState([]);
// טעינת טורניר
useEffect(() => {
    (async () => {
        try {
            const res = await axios.get(`${API}/api/dailyTournaments/${id}`)
            const t = res.data;
            
            setForm({
                name: t.name || "",
                date: t.date ? new Date(t.date).toISOString().slice(0, 10) : "",
                registrationLink: t.registrationLink || "",
                facebookLink: t.facebookLink || "",
                showOnSite: !!t.showOnSite,
                showFlyer: !!t.showFlyer,
                showRegistration: !!t.showRegistration,
                showFacebook: !!t.showFacebook,
                showGallery: !!t.showGallery,
                flyerUrl: t.flyerUrlHostinger || t.flyerUrl || null,
            });

            // פלייר
            if (t.flyerUrlHostinger) {
                setFlyerPreview(t.flyerUrlHostinger);
            } else if (t.flyerUrl) {
                setFlyerPreview(`${API}${t.flyerUrl}`);
            }

            // גלריה
            if (Array.isArray(t.galleryHostinger)) {
                const processed = t.galleryHostinger.map((url, index) => ({
                    _id: `host-${index}`, // מזהה זמני
                    src: url,
                }));
                setGallery(processed);
            } else if (Array.isArray(t.gallery)) {
                const processed = t.gallery.map((img) => ({
                    _id: img._id || `db-${Math.random()}`,
                    src: img.url ? `${API}${img.url}` : null,
                }));
                setGallery(processed);
            }
            } catch (err)
            {
                console.error("שגיאה בטעינת הטורניר:", err);
            }
            })();
            }, [id]);

            if (!form) return <p>טוען...</p>;

            // שינוי ערך שדה
            const handleChange = (e) => {
                const { name, value, type, checked } = e.target;
                setForm((prev) => ({...prev, [name]: type === "checkbox" ? checked : value}));
            };

            // פלייר חדש
            const onFlyerChange = (e) => {
                const file = e.target.files[0] || null;
                if (file) {
                    setFlyerFile(file);
                    setFlyerPreview(URL.createObjectURL(file));
                }
            };

            // גלרייה חדשה
            const onNewGalleryChange = (e) => {
                const files = Array.from(e.target.files || []);
                const newItems = files.map((f) => ({
                    file: f,
                    src: URL.createObjectURL(f),
                    }));
                    setGallery((prev) => [...prev, ...newItems]);
            };

            const removeGalleryItem = (index) => {
                setGallery((prev) => prev.filter((_, i) => i !== index));
            };

            //שמירה
            const handleSave = async (e) => {
                e.preventDefault();
                const data = new FormData();

                // הוספת שדות הצ'קבוקס וערכים רגילים
                Object.entries(form).forEach(([key, value]) => {
                    // אל תשלח את gallery או flyerPreview כאן
                    if (!["gallery", "flyerPreview"].includes(key)) {
                    data.append(key, value);
                    }
                });

                // פלייר חדש (
                if (flyerFile) {
                    data.append("flyer", flyerFile);
                } else if (form.flyerUrl) {
                    const flyerUrl = Array.isArray(form.flyerUrl) ? form.flyerUrl[0] : form.flyerUrl;
                    data.append("flyerUrl", flyerUrl);
                }

                // מזהי תמונות קיימות לשימור
                const keepUrls = gallery.filter(g => g._id && !g.file).map(g => g.src);
                data.append("galleryToKeep", JSON.stringify(keepUrls));

                // קבצים חדשים
                gallery.filter((g) => g.file).forEach(g => data.append("gallery", g.file));

                try {
                    await axios.put(`${API}/api/dailyTournaments/${id}`, data, {
                        headers: { 
                            "Content-Type": "multipart/form-data",
                            Authorization: `Bearer ${token}`   // 👈 חובה
                        },
                    });
                    toast.success('✅ הטורניר עודכן בהצלחה!');
                    navigate("/dailyTournaments"); // חזרה לרשימת הטורנירים
                } catch (err) {
                    console.error("שגיאה בעדכון הטורניר:", err);
                     toast.error('❌ עדכון הטורניר נכשל');
                }
            };

            // מחיקה
            const handleDelete = async () => {
                if (!window.confirm("את/ה בטוח/ה שברצונך למחוק את הטורניר?")) return;

                try {
                    await axios.delete(`${API}/api/dailyTournaments/${id}`, {
                        headers: { Authorization: `Bearer ${token}` },
                    });
                    toast.success('❌ הטורניר נמחק בהצלחה');
                    navigate("/dailyTournaments");
                } catch (err) {
                    console.error("שגיאה במחיקת הטורניר:", err);
                    toast.error('❌ מחיקת הטורניר נכשלה');
                }
            };

    return (
        <div className="edit-tournament card">
            {/* אייקון הבית בפינה שמאלית עליונה */}
            <div className="home-icon">
                <IoHome title="עמוד הבית" size={30} onClick={() => navigate("/")}/>
            </div>
            <div className="back-icon">
                <PiKeyReturnFill title="חזרה לעמוד הקודם" size={40} onClick={() => navigate("/tournaments")}/>
            </div>
            <h2>✏️ עריכת טורניר - {form.name}</h2>
            <form onSubmit={handleSave} className="form-grid">

            <label>
                שם הטורניר:
                <input type="text" name="name" value={form.name || ""} onChange={handleChange} className="input-field"/>
            </label>

            <label>
                תאריך:
                <input type="date" name="date" value={form.date} onChange={handleChange} className="input-field"/>
            </label>

            <label>
                תמונת פלייר:
                <input type="file" accept="image/*" onChange={onFlyerChange} className="input-field"/>
                {flyerPreview  && <img src={flyerPreview} alt="פלייר" className="preview" />}
            </label>

            <label>
                לינק הרשמה:
                <input type="text" name="registrationLink" value={form.registrationLink || ""} onChange={handleChange} className="input-field"/>
            </label>

            <label>
                לינק פייסבוק:
                <input type="text" name="facebookLink" value={form.facebookLink || ""} onChange={handleChange} className="input-field"/>
            </label>

            <fieldset className="gallery-fieldset">
                <legend>גלריה קיימת</legend>
                {gallery.length === 0 ? (
                <p>אין תמונות בגלריה</p>
                ) : (
                    <div className="preview-grid">
                        {gallery.map((img, i) => (
                            <div key={i} className="thumb">
                                <img src={img.src} alt={`g${i}`} />
                                <button type="button" onClick={() => removeGalleryItem(i)}>הסרה</button>
                            </div>
                        ))}
                    </div>
                )}
            </fieldset>

            <label>
                הוספת תמונות חדשות לגלריה
                <input
                type="file"
                accept="image/*"
                multiple
                onChange={onNewGalleryChange}
                className="input-field"/>
            </label>

            <div className="checks">
                <label><input type="checkbox" name="showOnSite" checked={!!form.showOnSite} onChange={handleChange} /> {" "} מוצג באתר</label>
                <label><input type="checkbox" name="showFlyer" checked={!!form.showFlyer} onChange={handleChange} /> {" "} פלייר</label>
                <label><input type="checkbox" name="showRegistration" checked={!!form.showRegistration} onChange={handleChange} /> {" "} כפתור הרשמה</label>
                <label><input type="checkbox" name="showFacebook" checked={!!form.showFacebook} onChange={handleChange} /> {" "} כפתור פייסבוק</label>
                <label><input type="checkbox" name="showGallery" checked={!!form.showGallery} onChange={handleChange} /> {" "} גלריה</label>
            </div>

            <div className="buttons">
                <button type="submit">💾 שמירת שינויים</button>
                <button type="button" onClick={handleDelete} className="delete">🗑️ מחיקת טורניר</button>
                <button type="button" onClick={() => navigate("/dailyTournaments")}>⬅️ חזרה</button>
            </div>

            </form>
        </div>
    );
};

export default EditDailyTournament;